import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Experiment, Variant } from '@americanexpress/one-experiments';
import { IN_SEAT } from '../../constants/dropdownConstants';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../../constants/experimentConstant';
import NotesSection from '../NotesSection/NotesSection';

const ChildAgeNote = ({ infants, children }) => {
  const hasInfantInSeat = infants.includes(IN_SEAT);
  const variantChildNote = (<NotesSection id="note_child_turns_two" />);
  const variantInfantNote = (<NotesSection id="infant_in_seat_note" />);

  return (
    <>
      <Experiment
        experimentName={HOMEPAGE_REDESIGN_EXPERIMENT}
        dimensionName="search_widget"
        defaultVariant="control"
      >
        <Variant variant="control">
          <div className="flex flex-row pad-1-b">
            <p>
              <span className="legal-1">
                <FormattedMessage id="note_child_turns_two" />
              </span>
            </p>
          </div>
        </Variant>
        <Variant variant="widget_a_with_hero">{variantChildNote}</Variant>
        <Variant variant="widget_a_no_hero">{variantChildNote}</Variant>
        <Variant variant="widget_b_with_hero">{variantChildNote}</Variant>
        <Variant variant="widget_b_no_hero">{variantChildNote}</Variant>
      </Experiment>
      {children}
      {hasInfantInSeat && (
        <Experiment
          experimentName={HOMEPAGE_REDESIGN_EXPERIMENT}
          dimensionName="search_widget"
          defaultVariant="control"
        >
          <Variant variant="control">
            <div className="flex flex-row pad-1-b">
              <p>
                <b>
                  <FormattedMessage id="infant_in_seat" />
                </b>
                &nbsp;
                <span className="legal-1">
                  <FormattedMessage id="an_infant_for_whom" />
                </span>
              </p>
            </div>
          </Variant>
          <Variant variant="widget_a_with_hero">{variantInfantNote}</Variant>
          <Variant variant="widget_a_no_hero">{variantInfantNote}</Variant>
          <Variant variant="widget_b_with_hero">{variantInfantNote}</Variant>
          <Variant variant="widget_b_no_hero">{variantInfantNote}</Variant>
        </Experiment>
      )}
    </>
  );
};

ChildAgeNote.propTypes = {
  infants: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.arrayOf(PropTypes.element),
};

export { ChildAgeNote as TestableChildAgeNote };

export default ChildAgeNote;
